import { useState, useEffect } from "react";

const AmountSlider = ({
  min = 100000,
  max = 5000000,
  step = 50000,
  value,
  onChange,
  color = "#7E02FC",
}) => {
  const [amount, setAmount] = useState(value ?? min);

  useEffect(() => {
    if (value !== undefined) {
      setAmount(value);
    }
  }, [value]);

  const handleChange = (e) => {
    const newValue = Number(e.target.value);

    setAmount(newValue);

    if (onChange) {
      onChange(newValue);
    }
  };

  const percentage = ((amount - min) / (max - min)) * 100;

  return (
    <div style={{ width: "100%" }}>
      <div
        style={{
          textAlign: "center",
          fontSize: 28,
          fontWeight: "bold",
          marginBottom: 20,
        }}
      >
        ${amount.toLocaleString("es-CO")}
      </div>

      <div
        style={{
          position: "relative",
          height: 8,
          borderRadius: 10,
          background: "#E5E7EB",
        }}
      >
        <div
          style={{
            position: "absolute",
            height: "100%",
            width: `${percentage}%`,
            background: color,
            borderRadius: 10,
          }}
        />

        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={amount}
          onChange={handleChange}
          style={{
            position: "absolute",
            width: "100%",
            top: "-8px",
            appearance: "none",
            background: "transparent",
            pointerEvents: "auto",
          }}
        />

        <style>{`
          input[type=range]::-webkit-slider-thumb{
              appearance:none;
              width:24px;
              height:24px;
              border-radius:50%;
              background:white;
              border:3px solid ${color};
              cursor:pointer;
              box-shadow:0 2px 6px rgba(0,0,0,.2);
          }

          input[type=range]::-moz-range-thumb{
              width:24px;
              height:24px;
              border-radius:50%;
              background:white;
              border:3px solid ${color};
              cursor:pointer;
          }

          input[type=range]::-webkit-slider-runnable-track{
              background:transparent;
          }

          input[type=range]::-moz-range-track{
              background:transparent;
          }
        `}</style>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: 15,
          fontWeight: 600,
          color: "#666",
        }}
      >
        <span>${min.toLocaleString("es-CO")}</span>
        <span>${max.toLocaleString("es-CO")}</span>
      </div>
    </div>
  );
};

export default AmountSlider;